<template>
  <ion-page>
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-buttons slot="start">
          <ion-back-button
            default-href="/home"
            color="light"
            text=""
          ></ion-back-button>
        </ion-buttons>
        <ion-title class="page-title">Support Center</ion-title>
      </ion-toolbar>
    </ion-header>
    <!--content start -->
    <ion-content>
      <ion-row
        @click="$router.push('/list/app-user-guide')"
        @keydown.enter="$router.push('/list/app-user-guide')"
        @keydown.space.prevent="$router.push('/list/app-user-guide')"
        role="button"
        tabindex="0"
        aria-label="App User Guide"
        class="support-row"
      >
        <ion-col size="9">
          <span class="support-txt">App User Guide</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row
        @click="$router.push('/list/account-related')"
        @keydown.enter="$router.push('/list/account-related')"
        @keydown.space.prevent="$router.push('/list/account-related')"
        role="button"
        tabindex="0"
        aria-label="Account Related"
        class="support-row"
      >
        <ion-col size="9">
          <span class="support-txt">Account Related</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row
        @click="$router.push('/list/order-related')"
        @keydown.enter="$router.push('/list/order-related')"
        @keydown.space.prevent="$router.push('/list/order-related')"
        role="button"
        tabindex="0"
        aria-label="Order Related"
        class="support-row"
      >
        <ion-col size="9">
          <span class="support-txt">Order Related</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <ion-row class="support-row">
        <ion-col size="9">
          <span class="support-txt">Term and conditions</span>
        </ion-col>
        <ion-col class="arrowright-icon position-right">
          <img src="assets/icon/arrow-right.png" />
        </ion-col>
      </ion-row>
      <hr class="support-row" />
      <div class="center-img">
        <img src="assets/images/notification-empty.png" />
      </div>
      <!--<span class="call-txt">Call us: 123 456 789</span>-->
      <!-- content end -->
      <ion-button
        expand="block"
        color="primary"
        class="carttext-btn"
        @click="openSendForm"
        >Send us an email</ion-button
      >
    </ion-content>
  </ion-page>
</template>
<style scoped>
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}
.support-row {
  border-top: 1px solid #f3f3f3;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 3%;
}
.support-row[role="button"] {
  cursor: pointer;
}
.support-row[role="button"]:focus-visible {
  outline: 2px solid #f87e63;
  outline-offset: 2px;
}
.support-row[role="button"]:hover {
  background-color: #f9f9f9;
}
.support-row[role="button"]:active {
  background-color: #f3f3f3;
}
.center-img {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
ion-button {
  --background: #ffffff;
  --background-hover: #dce8ff;
  --background-activated: #dce8ff;
  --background-focused: #dce8ff;
  --color: #1b1b1b;
  --border-radius: 4px;
  --border-color: #f3f3f3;
  --border-style: solid;
  --border-width: 1px;
  --ripple-color: #dce8ff;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 20px;
  margin-left: 15px;
  margin-right: 15px;
  height: 52px;
  text-transform: none;
}
ion-button:active {
  --color: #f87e63;
}
.carttext-btn {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin-top: 20px;
}
.support-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding-top: 5px;
}
.arrowright-icon {
  text-align: right;
  padding-top: 8px;
}
.position-right {
  position: absolute;
  right: 20px;
}
.call-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #828282;
  display: block;
  margin-top: 40px;
  margin-bottom: 15px;
}
</style>
<script>
import { defineComponent } from "vue";
import {
  IonRow,
  IonCol,
  IonButton,
  IonPage,
  IonContent,
  IonIcon,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
} from "@ionic/vue";

export default defineComponent({
  name: "SupportHomePage",
  components: {
    IonRow,
    IonCol,
    IonButton,
    IonPage,
    IonContent,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
  },
  methods: {
    openSendForm() {
      this.$router.push("/send-email-support");
    },
  },
});
</script>
